import React, { useEffect, useState, useContext } from 'react';
import axios from 'axios';
import { Link, useNavigate } from '@reach/router';
import Layout from '../../components/Layout';
import ResourceTemplate from '../../components/Resource';
import { Spinner } from 'reactstrap';
import Text from '../../components/Medata/search/civil/components/Text';
import Tags from '../../components/Medata/search/civil/components/Tags';
import TopicIcon from '../../components/Medata/search/civil/templates/TopicIcon';
import Breadcrumb from '../../components/Medata/breadcrumb';
import { countBy } from 'lodash';
import { Share } from '../../components/Medata/search/civil/components/Share';
import FileDownload from '../../components/Medata/search/civil/components/FileDownload';
import Comments from '../../components/Medata/search/civil/components/Comments';
import SendComments from '../../components/Medata/search/civil/components/SendComments';
import Subscription from '../../components/Medata/search/civil/components/Subscription';
import { MedataContext } from '../../ContexMedata';
import HomeSurvey from '../../components/Medata/home/home-survey';


const Dataset = ({ id, location }) => {
  const { state } = location;
  const [item, setItem] = useState(state && state.dataset ? state.dataset : {});
  const [hasWindow, checkForWindow] = useState(false);
  const [display, setDisplay] = useState('none');
  const [displayComment, setDisplayComment] = useState('none');
  const [iconCardClass, setIconCardClass] = useState('fa-chevron-down');
  const [iconCommentClass, setIconCommentClass] = useState('fa-chevron-down');
  const [spanText, setSpanText] = useState('Abrir detalles');
  const [spanCommentText, setCommentSpanText] = useState('Ver Comentarios');
  const [spanColor, setSpanColor] = useState('#53ACE9');
  const [spanCommentColor, setSpanCommentColor] = useState('#53ACE9');
  const url = window.location.href
  const [views, setViews] = useState('')
  const [downloads, setDownloads] = useState('')
  const { datasetDonwloads, setDatasetDonwloads } = useContext(MedataContext);


  useEffect(() => {
    async function getViews() {
      const { data } = await axios.get(`${process.env.REACT_APP_JSON_API_GET_DATA}${id}/${process.env.REACT_APP_JSON_API_GET_DATA_FIELDS}`);

      if (data.data.attributes.field_descargas == null) {
        setDownloads(0)
        setDatasetDonwloads(0)
      } else {
        setDownloads(data.data.attributes.field_descargas)
        setDatasetDonwloads(data.data.attributes.field_descargas)
      }

      if (data.data.attributes.field_visitas == null) {
        setViews(1)
      } else {

        setViews((data.data.attributes.field_visitas + 1))
      }

      const headers = {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json'
      };
      const auth = {
        username: process.env.REACT_APP_JSON_API_USER,
        password: process.env.REACT_APP_JSON_API_PASS
      }

      const dataPatch = {
        "data": {
          "type": "node--data",
          "id": id,
          "attributes": {
            "field_visitas": (data.data.attributes.field_visitas + 1)
          }
        }
      }

      await axios.patch(`${process.env.REACT_APP_JSON_API_GET_DATA}${id}`, dataPatch, {
        headers: headers,
        auth: auth
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
        console.log(error.config);
      });
    }
    getViews();
  }, [])

  useEffect(() => {
    if (window !== undefined) {
      checkForWindow(true);
    }
    async function getItem() {
      const { data } = await axios.get(
        `${process.env.REACT_APP_ROOT_URL}/metastore/schemas/dataset/items/${id}?show-reference-ids=true`
      );
      setItem(data);
    }
    if (!state || !state.dataset) {
      getItem();
    }
  }, [id, state]);

  const orgName =
    'publisher' in item && item.publisher ? item.publisher.data.name : '';
  const tag = 'keyword' in item ? item.keyword : [];
  const theme = 'theme' in item ? item.theme : [];

  function getPeriodicity(code) {
    if (!code) {
      return null;
    } else {
      let periodicityName = '';
      switch (code) {
        case 'R/P4Y':
          periodicityName = 'Cuatrienal';
          break;
        case 'R/P10Y':
          periodicityName = 'Decenal';
          break;
        case 'R/P1Y':
          periodicityName = 'Anual';
          break;
        case 'R/P2M':
          periodicityName = 'Bimestral';
          break;
        case 'R/P3.5D':
          periodicityName = 'Bisemanal';
          break;
        case 'R/P1D':
          periodicityName = 'Diario';
          break;
        case 'R/P2W':
          periodicityName = 'Quincenal';
          break;
        case 'R/P6M':
          periodicityName = 'Semestral';
          break;
        case 'R/P2Y':
          periodicityName = 'Bienal';
          break;
        case 'R/P3Y':
          periodicityName = 'Trienal';
          break;
        case 'R/P0.33W':
          periodicityName = 'Tres veces por semana';
          break;
        case 'R/P0.33M':
          periodicityName = 'Tres veces al mes';
          break;
        case 'R/PT1S':
          periodicityName = 'Actualizado continuamente';
          break;
        case 'R/P1M':
          periodicityName = 'Mensual';
          break;
        case 'R/P3M':
          periodicityName = 'Trimestral';
          break;
        case 'R/P0.5M':
          periodicityName = 'Quincenal';
          break;
        case 'R/P4M':
          periodicityName = 'Tres veces al año';
          break;
        case 'R/P1W':
          periodicityName = 'Semanal';
          break;
        case 'R/PT1H':
          periodicityName = 'Cada hora';
          break;
        case 'irregular':
          periodicityName = 'irregular';
          break;
        default:
          periodicityName = '-';
          break;
      }

      return periodicityName;
    }
  }

  function themes(theme) {
    if (!theme) {
      return null;
    } else {
      return theme.map((topic) => {
        return (
          <span className="mr-2" title={topic.data}>
            <span className="mr-2">{topic.data}</span>
            <TopicIcon
              title={topic.data}
              height={16}
              width={16}
              color="white"
              key={topic.identifier}
            />
          </span>
        );
      });
    }
  }

  function formats(distribution) {
    if (!distribution) {
      return null;
    }

    if (Array.isArray(distribution)) {
      var newDistribution = distribution.map((dist) => dist.data);
      var distributionWithUniqueFormats = getUniqueFormats(
        Object.entries(newDistribution)
      );

      const counted = countBy(newDistribution, (d) => {
        return d.format;
      });

      return distributionWithUniqueFormats.map(function (dist, idx) {
        var type = dist.mediaType ? dist.mediaType.split('/') : '';
        var backup = type ? type : 'data';
        var format = dist.format ? dist.format : backup;
        var finishIcon = '';
        switch (format.toLowerCase()) {
          case 'pdf':
            finishIcon = 'fa-solid fa-file-pdf';
            break;
          case 'csv':
            finishIcon = 'fa-solid fa-file-csv';
            break;
          case 'zip':
            finishIcon = 'fa-solid fa-file-zipper';
            break;
          case 'json':
            finishIcon = 'fa-solid fa-file-code';
            break;
          case 'tablero':
            finishIcon = 'fa-solid fa-chart-area';
            break;
          case 'html':
            finishIcon = 'fa-brands fa-html5';
            break;
          case 'data':
            finishIcon = 'fa-solid fa-file-archive';
            break;
        }
        return (
          <i className={`mr-2 ${finishIcon}`} key={idx} title={format}>
            <span
              className="totalFormat"
              key={'total' + idx}
            >{`x ${counted[format]}`}</span>
          </i>
        );
      });
    }

    return null;
  }

  function getUniqueFormats(formats) {
    var unique = [];
    return formats.reduce(function (a, b) {
      if (unique.indexOf(b[1].format) === -1) {
        unique.push(b[1].format);
        a.push(b[1]);
      }
      return a;
    }, []);
  }

  function toogleTechCardVisibility() {
    setDisplay(display === 'none' || display === '' ? 'block' : 'none');
    setIconCardClass(
      iconCardClass === 'fa-chevron-down' ? 'fa-chevron-up' : 'fa-chevron-down'
    );
    setSpanColor(spanColor === '#FA8D2D' ? '#53ACE9' : '#FA8D2D');
    setSpanText(
      spanText === 'Cerrar detalles' ? 'Abrir detalles' : 'Cerrar detalles'
    );
  }

  function toogleCommentVisibility() {
    setDisplayComment(displayComment === 'none' || displayComment === '' ? 'block' : 'none');
    setIconCommentClass(
      iconCommentClass === 'fa-chevron-down' ? 'fa-chevron-up' : 'fa-chevron-down'
    );
    setSpanCommentColor(spanColor === '#FA8D2D' ? '#53ACE9' : '#FA8D2D');
    setCommentSpanText(
      spanCommentText === 'Cerrar comentarios' ? 'Ver comentarios' : 'Cerrar comentarios'
    );
  }

  function goToClose(item) {
    if (
      item &&
      item.theme &&
      Array.isArray(item.theme) &&
      item.theme.length > 0
    ) {
      const theme = item.theme[0];
      window.location.assign(`/search/?theme=${theme.data}`);
    }
  }

  const navigate = useNavigate();
  return (
    <Layout
      title={`Dataset - ${item.title}`}
      headerClass="header header--small"
    >
      {item && item.theme && (
        <Breadcrumb themes={item.theme} curretItem={{ title: item.title }} />
      )}

      <section class="header-section data">
        <div class="data-container">
          <div>
            <p class="title title--black">{item.title}</p>
            <p class="paragraph paragraph--black margin-bottom-sm">
              <Text value={item.description} />
            </p>
          </div>
          <div class="button-close">
            <button
              onClick={() => goToClose(item)}
              style={{ background: 'none', border: 'none' }}
            >
              {' '}
              x{' '}
            </button>
          </div>
        </div>
      </section>

      <section class="data-technical-section">
        <div class="data-technical-info">
          <div class="data-block container">
            <div class="data-technical-info-list row">
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Dependencia:</span> {orgName}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Última modificación:</span> {item.modified || ''}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Formato(s):</span>{' '}
                {item.distribution && formats(item.distribution)}
              </div>
            </div>
            <div class="data-technical-info-list row">
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Categoria:</span>{' '}
                {theme.length > 0 && themes(theme)}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Vistas:</span>{' '}
                {views}
              </div>
              <div class="data-technical-info-item col-12 col-md-4">
                <span>Descargas:</span>{' '}
                {/* {downloads} */}
                {datasetDonwloads}
              </div>
            </div>
          </div>
        </div>

        <div class="data-sheet data-block">
          <div class="data-card">
            <div class="data-card-header">
              <p class="subtitle subtitle--black">
                <b>Ficha técnica</b>
              </p>
              <div onClick={() => toogleTechCardVisibility()}>
                <span
                  class="text"
                  style={{ color: spanColor, marginRight: '10px' }}
                >
                  {' '}
                  {spanText}
                </span>{' '}
                <i id="icon-card" className={`fa-solid ${iconCardClass}`}></i>
              </div>
            </div>
            <div
              id="card-body"
              class="data-card-body"
              style={{ display: display }}
            >
              <table class="data-table">
                <tbody>
                  <tr>
                    <th>Dependencias</th>
                    <th>Fecha de modificación</th>
                    <th>Fecha de publicación</th>
                    <th>Frecuencia</th>
                    <th>Identificador</th>
                    <th>Estándar de datos</th>
                    <th>Cobertura temporal</th>
                    <th>Licencia</th>
                  </tr>
                  <tr>
                    <td>{orgName}</td>
                    <td>
                      {'modified' in item && item.modified
                        ? item.modified
                        : '-'}
                    </td>
                    <td>
                      {'issued' in item && item.issued ? item.issued : '-'}
                    </td>
                    <td>
                      {'accrualPeriodicity' in item && item.accrualPeriodicity
                        ? getPeriodicity(item.accrualPeriodicity)
                        : '-'}
                    </td>
                    <td>
                      {'identifier' in item && item.identifier
                        ? item.identifier
                        : '-'}
                    </td>
                    <td>
                      {'conformsTo' in item && item.conformsTo
                        ? item.conformsTo
                        : '-'}
                    </td>
                    <td>
                      {'temporal' in item && item.temporal
                        ? item.temporal
                        : '-'}
                    </td>
                    <td>
                      {'license' in item && item.license ? item.license : '-'}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="data-view">
          <div class="data-card">
            <div class="data-card-header">
              <p class="subtitle subtitle--black">
                <b>Vista previa</b>
              </p>
            </div>
            <div class="data-card-body">
              {Object.keys(item).length ? (
                <div>
                  {hasWindow &&
                    item.distribution &&
                    item.distribution.filter((dist) => dist.data.format.toLowerCase() == 'csv').map((dist, i) => {
                      if (i == 0) {
                        return (
                          <ResourceTemplate
                            key={dist.identifier}
                            resource={dist}
                            identifier={dist.identifier}
                            id={id}
                          />
                        );
                      } else {
                        return (
                          <>
                            <div className='containerResource'>
                              <p className='subtitle subtitle--black'><b>{dist.data.title}</b></p>
                              <div className='containerResourceButtons'>
                                <FileDownload
                                  title={'Descargar'}
                                  label={'Descargar'}
                                  format={dist.data.format}
                                  downloadURL={dist.data.downloadURL ? dist.data.downloadURL : dist.data.accessURL}
                                  id={id}
                                />
                                <div className='data-actions pl-2'>
                                  <a href={`/resource/${dist.identifier}`} title="Ver" className='button button-secondary' target='_blank'>
                                    <i className='fa-solid fa-eye' />
                                    {` Visualizar`}
                                  </a>
                                </div>
                              </div>
                            </div>
                            <hr />
                          </>
                        )
                      }
                    })
                  }
                  {hasWindow &&
                    item.distribution &&
                    item.distribution.filter((dist) => dist.data.format.toLowerCase() != 'csv').map((dist) => {
                      return (
                        <ResourceTemplate
                          key={dist.identifier}
                          resource={dist}
                          identifier={dist.identifier}
                          id={id}
                        />
                      );
                    })

                  }
                  <Tags tags={tag} path="/search/?keyword=" label="Etiquetas" />
                  <hr />
                  <p>
                    La información de esta página también está disponible vía{' '}
                    <Link
                      to={`/dataset/${item.identifier}/api`}
                      state={{ dataset: { ...item } }}
                    >
                      API
                    </Link>
                  </p>
                  <Share url={url} />
                </div>
              ) : (
                <div className="row">
                  <Spinner color="primary" />
                </div>
              )}
            </div>
          </div>
        </div>
        <div class="data-view">
          <div class="data-card">
            <div class="data-card-header">
              <p class="subtitle subtitle--black">
                <b>Comentarios</b>
              </p>
              <div onClick={() => toogleCommentVisibility()}>
                <span
                  class="text"
                  style={{ color: spanCommentColor, marginRight: '10px' }}
                >
                  {' '}
                  {spanCommentText}
                </span>{' '}
                <i id="icon-card" className={`fa-solid ${iconCommentClass}`}></i>
              </div>
            </div>
            <div style={{ display: displayComment }}>
              <div class="data-card-body">
                <SendComments id={id} />
              </div>
              <div class="data-card-body">
                <Comments id={id} />
              </div>
            </div>
          </div>
        </div>
        <Subscription id={id} />
        <section className="newsletter-section">
          <div className="container-home">
            <HomeSurvey />
          </div>
        </section>
      </section>
    </Layout>
  );
};

export default Dataset;
